import { useState, useCallback, useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { SET_REQUEST_SCHEDULE_EMAIL_UPDATES_DIALOGUE_OPEN, REQUEST_SCHEDULE_EMAIL_UPDATES, SiteboardApiValidator, } from '../actions/types';
import { siteboardAction, setAlert, } from '../actions/defaultActions';
import { debugLog, getServerApiResponse } from '../Util.js';

import PopupWindow from './PopupWindow';
import PushButton from './PushButton';

import LinkIcon from '../icons/linkIcon';
import CircleCheckIcon from '../icons/circleCheckIcon';
import Logo from '../SiteBoard_Logo';

const RequestScheduleEmailUpdatesDialogue = ({ _shareScheduleCode, _isUsingShareScheduleLink, _localOnlyMode, siteboardAction, setAlert }) => {
  const inputStyle = 'w-full text-white rounded-md px-3 py-1.5 bg-[#444247] hover:bg-[#656565] focus:bg-[#656565]';
  const FORM_PAGE = 'FORM_PAGE';
  const SENT_EMAIL_PAGE = 'SENT_EMAIL_PAGE';

  const [currentPage, setCurrentPage] = useState(FORM_PAGE);
  const [hasChangedScreen, setHasChangedScreen] = useState(false);
  const [inputFirstName, setInputFirstName] = useState('');
  const [inputLastName, setInputLastName] = useState('');
  const [inputCompanyName, setInputCompanyName] = useState('');
  const [inputEmail, setInputEmail] = useState('');

  const closeDialogue = useCallback(() => {
    siteboardAction(SET_REQUEST_SCHEDULE_EMAIL_UPDATES_DIALOGUE_OPEN, { isOpen: false });
  }, [siteboardAction]);

  const submitForm = () => {
    setCurrentPage(SENT_EMAIL_PAGE);
    //const onApiSuccess = (data) => {
    //  try {
    //    const validOutput = SiteboardApiValidator[REQUEST_SCHEDULE_EMAIL_UPDATES].validateOutput(data); 
    //    setCurrentPage(SENT_EMAIL_PAGE);
    //  } catch(error) {
    //    onApiError(error.message);
    //  }
    //};
    //const onApiError = (errorMessage) => {
    //  setAlert(typeof errorMessage === 'string' ? errorMessage : 'There was an error submitting your schedule updates request');
    //};
    //getServerApiResponse({ 
    //  action: REQUEST_SCHEDULE_EMAIL_UPDATES,
    //    shareCode: _shareScheduleCode,
    //    firstName: inputFirstName,
    //    lastName: inputLastName,
    //    companyName: inputCompanyName,
    //    email: inputEmail,
    //}, onApiSuccess, onApiError);
  };

  useEffect(() => {
    if(currentPage === FORM_PAGE) return;
    setHasChangedScreen(true);
  }, [currentPage]);

  const onBackButton = currentPage === FORM_PAGE ? null : () => { setCurrentPage(FORM_PAGE); };

  return (
    <PopupWindow 
      title={currentPage === FORM_PAGE ? 'Request Email Updates' : 'Check Your Email'}
      closeDialogue={closeDialogue}
      onBackButton={onBackButton}
      bgStyle='bg-[#333]'
    >
      {currentPage === FORM_PAGE &&
        <div className={`flex flex-col gap-4 bg-[#333] max-w-screen-sm text-white ${hasChangedScreen ? 'animate-right-fade' : ''}`}>
          <div className='w-[100vw] max-w-full'></div>
          <div className='font-medium'>Please confirm the information below to receive schedule updates.</div>
          <div className='flex flex-col gap-y-6'>
            {/* First and Last name */}
            <div className='flex gap-x-2'>
              <div className='w-1/2'>
                <label className='block text-sm font-medium mb-1'>First Name</label>
                <div className='rounded-[12px] border border-[#0000003f] h-[32px] '>
                  <input 
                    value={inputFirstName}
                    className={inputStyle}
                    type='text' 
                    onChange={(event) => { setInputFirstName(event.target.value); }}
                  />
                </div>
              </div>
              <div className='w-1/2'>
                <label className='block text-sm font-medium mb-1'>Last Name</label>
                <div className='rounded-[12px] border border-[#0000003f] h-[32px] '>
                  <input 
                    value={inputLastName}
                    className={inputStyle}
                    type='text' 
                    onChange={(event) => { setInputLastName(event.target.value); }}
                  />
                </div>
              </div>
            </div>
            <div>
              <label className='block text-sm font-medium mb-1'>Company Name</label>
              <div className='rounded-[12px] border border-[#0000003f] h-[32px] '>
                <input 
                  value={inputCompanyName}
                  className={inputStyle}
                  type='text' 
                  onChange={(event) => { setInputCompanyName(event.target.value); }}
                />
              </div>
            </div>
            {/* Email Input */}
            <div>
              <label className='block text-sm font-medium mb-1'>Email</label>
              <div className='rounded-[12px] border border-[#0000003f] h-[32px] '>
                <input 
                  value={inputEmail}
                  className={inputStyle}
                  type='text' 
                  onChange={(event) => { setInputEmail(event.target.value); }}
                />
              </div>
            </div>
            {/* submit email button */}
            <div className='flex gap-4'>
              <button  
                className={`border border-[#888] hover:border-[#000] hover:bg-[#000] text-white w-full py-[7px] font-bold select-none rounded-lg`}
                onClick={() => { closeDialogue(); }}
              >
                Cancel
              </button>
              <PushButton 
                textColor='black'
                bgColor='#f9a928'
                hoverBgColor='#f79800'
                onClick={() => { submitForm(); }}
              >
                Confirm
              </PushButton>
            </div>
          </div>
        </div>
      }
      {currentPage === SENT_EMAIL_PAGE &&
        <div className={`flex flex-col gap-4 bg-[#333] max-w-screen-sm text-white py-4 animate-left-fade`}>
          <div>We sent an email to <b>{inputEmail}</b>.</div>
          <div>Please check your inbox and click the provided link to verify your email and start receiving schedule updates.</div>
          <div className='opacity-60'>Didn't receive the email? Check your spam folder or wait up to 2 minutes for delivery.</div>
        </div>
      }
    </PopupWindow>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {
  _isUsingShareScheduleLink: state.localEphemeral.isUsingShareScheduleLink,
  _shareScheduleCode: state.localEphemeral.shareScheduleCode,
  _localOnlyMode: state.serverSynced.localOnlyMode,
}};
export default connect(mapStateToProps, { siteboardAction, setAlert, })(RequestScheduleEmailUpdatesDialogue);
